import React from "react";
import { Card, CardBody, Spinner } from "reactstrap";
import {
    AlertTriangle,
    TrendingDown,
    XCircle,
    Users
} from "react-feather";
import { useAlertsOverview } from "../../Hooks/useAlertsOverview";

/**
 * Presentación de cada tipo de alerta.
 *
 * Las claves son los ALERT_TYPES de insight-ms y llegan tal cual en
 * summary.by_type. El orden del array es el orden en que se pintan; el conteo
 * lo pone el backend, aquí sólo se le da forma.
 */
const ALERT_CARDS = [
    {
        type: "FAILED_PURCHASE_ATTEMPTS",
        icon: AlertTriangle,
        color: "#F04438",
        text: "Usuarios con +3 intentos\nde compra fallidos"
    },
    {
        type: "NETWORK_NO_GROWTH",
        icon: TrendingDown,
        color: "#F79009",
        text: "Redes sin crecimiento\nen el periodo seleccionado"
    },
    {
        type: "SALES_DROP",
        icon: XCircle,
        color: "#F04438",
        text: "Caídas abruptas en ventas\nen el periodo seleccionado"
    },
    {
        type: "NETWORK_DEPENDENCY",
        icon: Users,
        color: "#F79009",
        text: "Distribuidores con alta dependencia\nde su red inferior"
    }
];

const CriticalAlertsCard = () => {

    const { countsByType, summaryLoading, error } = useAlertsOverview();

    return (

        <Card className="border-0 shadow-sm w-100">

            <CardBody className="p-3">

                <h5
                    className="fw-bold mb-2"
                    style={{
                        color: "#101828",
                        fontSize: 16
                    }}
                >
                    Alertas Críticas
                </h5>

                {
                    summaryLoading && (
                        <div className="text-center py-4">
                            <Spinner size="sm" />
                        </div>
                    )
                }

                {
                    !summaryLoading && error && (
                        <div
                            style={{
                                color: "#667085",
                                fontSize: 13
                            }}
                        >
                            No se pudieron cargar las alertas.
                        </div>
                    )
                }

                {

                    !summaryLoading && !error && ALERT_CARDS.map((item, index) => {

                        const Icon = item.icon;
                        // Un tipo sin alertas abiertas no viene en el mapa; se
                        // pinta en 0 y no se esconde, para que la tarjeta
                        // siempre muestre las cuatro filas.
                        const count = countsByType?.[item.type] ?? 0;

                        return (

                            <div
                                key={item.type}
                                className="d-flex align-items-center py-2"
                                style={{
                                    borderBottom:
                                        index !== ALERT_CARDS.length - 1
                                            ? "1px solid #EAECF0"
                                            : "none"
                                }}
                            >

                                <div
                                    style={{
                                        width: 28,
                                        display: "flex",
                                        justifyContent: "center",
                                        marginRight: 10,
                                        flexShrink: 0
                                    }}
                                >

                                    <Icon
                                        size={18}
                                        color={item.color}
                                        strokeWidth={2}
                                    />

                                </div>

                                {/*
                                  minWidth en vez de width fija: el contador
                                  tenía 55px con fuente de 32, así que un número
                                  de cuatro cifras se salía de su columna y
                                  empujaba el texto. Ahora reserva el ancho pero
                                  puede crecer.
                                */}
                                <div
                                    style={{
                                        minWidth: 44,
                                        color: item.color,
                                        fontWeight: 700,
                                        fontSize: 24,
                                        lineHeight: "28px",
                                        marginRight: 12,
                                        flexShrink: 0
                                    }}
                                >
                                    {count.toLocaleString("es-CO")}
                                </div>

                                <div
                                    style={{
                                        flex: 1,
                                        color: "#667085",
                                        fontSize: 12.5,
                                        lineHeight: "17px",
                                        whiteSpace: "pre-line"
                                    }}
                                >
                                    {item.text}
                                </div>

                            </div>

                        );

                    })

                }

            </CardBody>

        </Card>

    );

};

export default CriticalAlertsCard;
